module.exports = __webpack_public_path__ + "static/media/BALANCING_OFF.2d009ba8.png";